import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { Attachment } from "tekkr-common/dist/model/attachments";
import { AttachmentReferenceType } from "tekkr-common/dist/enums";

type SupportedAttachmentTypes = AttachmentReferenceType.URL | AttachmentReferenceType.File;

interface Input {
    projectId: string;
    target?: string[];
    attachments: Extract<Attachment["reference"], { type: SupportedAttachmentTypes }>[];
}

export function useCreateProjectAttachmentsMutation() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (input: Input) => {
            const res = await apiClient.createProjectAttachment({
                params: {
                    projectId: input.projectId,
                },
                body: {
                    target: input.target,
                    attachments: input.attachments,
                },
            });
            if (res.status !== 200) {
                throw new Error(`failed to create project attachments: ${res.status}`);
            }
            await queryClient.invalidateQueries({
                queryKey: ["project", input.projectId, "attachments"],
            });
        },
    });
}
